import { createFileRoute, Navigate } from '@tanstack/react-router'
import { GovernanceLayout } from '@/components/governance/governance-layout'
import { ApprovalQueue } from '@/components/governance/approval-queue'
import { usePermissions } from '@/lib/hooks/use-permissions'

export const Route = createFileRoute('/_authenticated/governance/')({
  component: GovernanceApprovalsPage,
})

function GovernanceApprovalsPage() {
  const { canViewApprovals, canViewAuditLogs, isLoading } = usePermissions()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    )
  }

  if (!canViewApprovals && canViewAuditLogs) {
    return <Navigate to="/governance/audit-logs" />
  }

  if (!canViewApprovals && !canViewAuditLogs) {
    return <Navigate to="/" />
  }

  return (
    <GovernanceLayout activeTab="approvals">
      <ApprovalQueue />
    </GovernanceLayout>
  )
}
